<template>
    <crud-update
        :open="open"
        :loading="loading"
        title="Editar Plan"
        :errorMessage="errorMessage"
        @update="update"
        @close="$emit('close')"
    >
        <plan-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>
import PlanProvider from '../../../providers/PlanProvider'
import { CrudUpdate } from '@dracul/common-frontend'
import { ClientError } from '../../../../../errors'
import PlanForm from '../PlanForm'

export default {
    name: 'PlanUpdate',
    components: { PlanForm, CrudUpdate },
    props: {
        open: { type: Boolean, default: true },
        plan: { type: Object, required: true }
    },
    data() {
        return {
            errorMessage: '',
            inputErrors: {},
            loading: false,
            form: {
                id: this.plan.id,
                nombre: this.plan.nombre,
                descripcion: this.plan.descripcion,
                active: this.plan.active !== false,
                roleTemplates: (this.plan.roleTemplates || []).map(rt => ({
                    roleName: rt.roleName,
                    permissions: rt.permissions ? [...rt.permissions] : [],
                    childRoleNames: rt.childRoleNames ? [...rt.childRoleNames] : []
                }))
            }
        }
    },
    methods: {
        update() {
            if (this.$refs.form.validate()) {
                this.loading = true
                PlanProvider.updatePlan(this.form)
                    .then(r => {
                        if (r) {
                            this.$emit('planUpdated', r.data.adminPlanUpdate)
                            this.$emit('close')
                        }
                    })
                    .catch(error => {
                        let clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => this.loading = false)
            }
        }
    }
}
</script>
